/**
 * Configuration Constants - Frontend constants for configuration management
 */
export const CONFIGURATION_TYPES = {
    SYSTEM: 'System',
    USER_EXPERIENCE: 'UserExperience',
    APP_CONFIGURATION: 'AppConfiguration',
    DB_CONFIGURATION: 'DBConfiguration',
    SYSTEM_PROTECTED_READ_ONLY: 'SystemProtectedReadOnly'
};
import { constants } from '../constants';
export const CONFIGURATION_TYPE_LABELS = {
    [CONFIGURATION_TYPES.SYSTEM]: constants.configuration_type_system,
    [CONFIGURATION_TYPES.USER_EXPERIENCE]: constants.configuration_type_user_experience,
    [CONFIGURATION_TYPES.APP_CONFIGURATION]: constants.configuration_type_app_configuration,
    [CONFIGURATION_TYPES.DB_CONFIGURATION]: constants.configuration_type_db_configuration,
    [CONFIGURATION_TYPES.SYSTEM_PROTECTED_READ_ONLY]: constants.configuration_type_system_protected_read_only
};
export const VALUE_TYPES = {
    STRING: 'string',
    NUMBER: 'number',
    BOOLEAN: 'boolean',
    OBJECT: 'object'
};
export const VALUE_TYPE_LABELS = {
    [VALUE_TYPES.STRING]: constants.configuration_value_type_text,
    [VALUE_TYPES.NUMBER]: constants.configuration_value_type_number,
    [VALUE_TYPES.BOOLEAN]: constants.configuration_value_type_boolean,
    [VALUE_TYPES.OBJECT]: constants.configuration_value_type_json_object
};
